// extracted by mini-css-extract-plugin
module.exports = {"selections":"BreakdownDrawer-module__selections___d2w3G"};